import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
const CONFIG_URL = "/plugins/org.graylog.plugins.securityapp/tour/ai_report_demo_config";
export const AI_REPORT_DEMO_CONFIG_QUERY_KEY = ["ai-report-demo", "config"];
const fetchAIReportDemoConfig = () => fetch("GET", qualifyUrl(CONFIG_URL)).catch((error) => {
  UserNotification.error(
    `Fetching AI Report demo configuration failed with status: ${error}`,
    "Could not load AI Report demo configuration"
  );
  return { investigationId: "" };
});
export const updateAIReportDemoConfig = (config) => fetch("PUT", qualifyUrl(CONFIG_URL), config).catch((error) => {
  UserNotification.error(
    `Saving AI Report demo configuration failed with status: ${error}`,
    "Could not save AI Report demo configuration"
  );
  throw error;
});
const useAIReportDemoConfig = () => {
  var _a;
  const { data, isLoading } = useQuery({
    queryKey: AI_REPORT_DEMO_CONFIG_QUERY_KEY,
    queryFn: fetchAIReportDemoConfig,
    retry: false
  });
  return {
    demoInvestigationId: (_a = data == null ? void 0 : data.investigationId) != null ? _a : "",
    isLoading
  };
};
export default useAIReportDemoConfig;
